// extracted by mini-css-extract-plugin
export var body = "styles-module--body--IPFFb";
export var close = "styles-module--close--VJDA9";
export var formSearch = "styles-module--formSearch--Esm8N";
export var inputContainer = "styles-module--inputContainer--NIFCO";
export var inputSearch = "styles-module--inputSearch--DrpJK";
export var modal = "styles-module--modal--rwOIZ";
export var searchIcon = "styles-module--searchIcon--2Yc-F";
export var slideInTop = "styles-module--slide-in-top--Uj4YM";